import React, { useEffect, useState } from "react";
import axios from "axios";
import * as ReactBootstrap from "react-bootstrap";
import ProgressBar from "react-bootstrap/ProgressBar";
import Editbtn from "../Dashboard/images/circum_edit.svg";
import { Pagination } from "react-bootstrap";

import eye from "../Dashboard/images/eye.svg";
import trash from "../Dashboard/images/trash.svg";
import circum from "../Dashboard/images/circum_edit.svg";
import { baseURL } from "../../config";

const ListClusterAndCompTable = () => {
  const [posts, setPosts] = useState({ grades: [] });
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(10);
  const [editedgrade, setEditedGrade] = useState(null);
  const [selectedSkill, setSelectedSkill] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [gradesToDelete, setGradesToDelete] = useState(null);

  useEffect(() => {
    const fetchPostList = async () => {
      try {
        const { data } = await axios(`${baseURL}/allgrades`);
        console.log("Fetched data:", data);
        if (Array.isArray(data.grades)) {
          setPosts({ grades: data.grades });
        } else {
          console.error("Data is not an array:", data);
        }
      } catch (error) {
        console.error("Error fetching posts:", error);
      }
    };
    fetchPostList();
  }, []);

  const handleDelete = async (gradesId) => {
    try {
      setGradesToDelete(gradesId);
      setShowDeleteModal(true);
    } catch (error) {
      console.error("Error deleting category:", error);
    }
  };

  const handleSaveEditedGrade = async () => {
    try {
      const response = await axios.post(
        `${baseURL}/gradesupdate?id=${editedgrade.id}`,
        editedgrade
      );
      console.log("Updated Grade:", response.data);
      // Update the state with the updated grade
      const updatedGrades = posts.grades.map((grades) => {
        if (grades.id === editedgrade.id) {
          return editedgrade;
        }
        return grades;
      });
      setPosts({ grades: updatedGrades });
      setShowEditModal(false);
    } catch (error) {
      if (error.response && error.response.status === 404) {
        console.error("Grade not found. Please try again.");
      } else {
        console.error("Error updating Grade:", error);
      }
    }
  };

  const confirmDelete = async () => {
    try {
      await axios.get(`${baseURL}/deletegrade?id=${gradesToDelete}`);
      const updatedGrades = posts.grades.filter(
        (grades) => grades.id !== gradesToDelete
      );
      setPosts({ grades: updatedGrades });
      setShowDeleteModal(false);
    } catch (error) {
      console.error("Error deleting Grade:", error);
    }
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
  };

  // Get current posts
  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = posts.grades.slice(indexOfFirstPost, indexOfLastPost);

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Define handleCloseEditModal, handleCloseCommentModal, handleCloseViewModal functions
  const handleCloseEditModal = () => {
    setShowEditModal(false);
  };

  // Define handleEdit, handleComment, handleView functions
  const handleEdit = (clustername) => {
    setEditedGrade(clustername);
    setShowEditModal(true);
  };

  // Define handleSaveEditedSmartGoal function

  return (
    <div>
      <div className="col-lg-12 d-flex mt-2 pb-3">
        <div className="col-lg-6">
          <h4 className="text-start">CLUSTER - COMPETENCIES </h4>
        </div>
        <div className="col-lg-6 text-end bg-white ">
          <a
            href="/comboclusandcomp"
            className="text-decoration-none text-white"
          >
            <button type="button" class="btn btn-danger rounded-pill">
              Create +
            </button>
          </a>
        </div>
      </div>
      <ReactBootstrap.Table striped bordered hover size="sm">
        <thead className="text-center">
          <tr>
            <th>#</th>
            <th>ClusterName</th>
            <th>Competencies Linked</th>
            <th>Created By</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>1</td>
            <td>Operation</td>
            <td>
              Resource Planning<td>Equipment operating</td>
            </td>
            <td>Manager</td>

            <td className="text-center">
              <img src={circum} alt="" />{" "}
            </td>
          </tr>

          <tr>
            <td>2</td>
            <td>Administration</td>
            <td>Administration Management</td>
            <td>Manager</td>
            <td className="text-center">
              <img src={circum} alt="" />{" "}
            </td>
          </tr>

          <tr>
            <td>3</td>
            <td>Customer service</td>
            <td>service excellence</td>
            <td>Manager</td>
            <td className="text-center">
              <img src={circum} alt="" />{" "}
            </td>
          </tr>

          <tr>
            <td>4</td>
            <td>Maintenance</td>
            <td>Maintenance Planning and Schedule</td>
            <td>Manager</td>
            <td className="text-center">
              <img src={circum} alt="" />{" "}
            </td>
          </tr>
        </tbody>
      </ReactBootstrap.Table>

      {/* Delete confirmation modal */}
      <ReactBootstrap.Modal
        show={showDeleteModal}
        onHide={handleCloseDeleteModal}
      >
        <ReactBootstrap.Modal.Header closeButton>
          <ReactBootstrap.Modal.Title>
            Confirm Deletion
          </ReactBootstrap.Modal.Title>
        </ReactBootstrap.Modal.Header>
        <ReactBootstrap.Modal.Body>
          Are you sure you want to delete this Grade?
        </ReactBootstrap.Modal.Body>
        <ReactBootstrap.Modal.Footer>
          <ReactBootstrap.Button
            variant="secondary"
            onClick={handleCloseDeleteModal}
          >
            Cancel
          </ReactBootstrap.Button>
          <ReactBootstrap.Button variant="danger" onClick={confirmDelete}>
            Delete
          </ReactBootstrap.Button>
        </ReactBootstrap.Modal.Footer>
      </ReactBootstrap.Modal>

      {/* Edit Modal */}
      {showEditModal && editedgrade && (
        <ReactBootstrap.Modal
          show={showEditModal}
          onHide={handleCloseEditModal}
        >
          <ReactBootstrap.Modal.Header closeButton>
            <ReactBootstrap.Modal.Title>Skills</ReactBootstrap.Modal.Title>
          </ReactBootstrap.Modal.Header>

          <ReactBootstrap.Modal.Footer>
            <ReactBootstrap.Button
              variant="secondary"
              onClick={handleCloseEditModal}
            >
              Close
            </ReactBootstrap.Button>
            {/* On clicking the Update button, call handleSaveEditedSmartGoal to save changes */}
            <ReactBootstrap.Button
              variant="primary"
              onClick={handleSaveEditedGrade}
            >
              Update
            </ReactBootstrap.Button>
          </ReactBootstrap.Modal.Footer>
        </ReactBootstrap.Modal>
      )}

      {/* Pagination */}
      <ReactBootstrap.Pagination>
        {Array.from(
          { length: Math.ceil(posts.grades.length / postsPerPage) },
          (_, index) => (
            <ReactBootstrap.Pagination.Item
              key={index}
              onClick={() => paginate(index + 1)}
            >
              {index + 1}
            </ReactBootstrap.Pagination.Item>
          )
        )}
      </ReactBootstrap.Pagination>
    </div>
  );
};

export default ListClusterAndCompTable;
